import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { Link, useLocation } from 'react-router-dom'
import { useTypedSelector } from 'src/redux/index'
import { CreateContestContainer, Wrapper, CreateContestForm } from './style'
import { DatePicker } from 'src/components/Global/Date/Date'
import PaymentSelect from 'src/components/Payment/PaymentSelect/PaymentSelect'
import { useDispatch } from 'react-redux'
import { XContestTypes } from 'src/redux/types/xContest'
import { action } from 'typesafe-actions'
import { ModalButton } from 'src/components/Global/Button/Button'

const CreateContest = () => {
  const params = useParams()
  const { id } = params

  // console.log(id)
  let location = useLocation()
  const dispatch = useDispatch()

  const allContest = useTypedSelector((state) => state.xcontest.all)
  const joinForm = useTypedSelector((state) => state.xcontest.joinForm)
  console.log(joinForm)
  const singleContest = allContest.filter((item: any) => item?.id === id)
  const data = singleContest[0]
  const { name, end_date } = data

  // console.log(id, 'helllo')

  const [contestDate, setContestDate] = useState({
    start_date: '',
  })
  const { start_date } = contestDate

  const handleDispatch = () => {
    dispatch(
      action(XContestTypes.CONTEST_FORM_DATA, {
        ...joinForm,
        contest_id: id,
        start_date: start_date,
        maturity_date: end_date,
      })
    )
  }

  const handleSubmit = (e: any) => {
    e.preventDefault()
  }

  const handleChange = (e: any) => {
    const { name, value } = e.target
    const newData: any = { ...contestDate }
    newData[name] = value
    setContestDate(newData)
  }

  useEffect(() => {
    setContestDate({
      ...joinForm,
      start_date: joinForm?.start_date,
    })
  }, [dispatch, joinForm])

  const Disabled = () => {
    if (!start_date) {
      return 'blur'
    }
    return null
  }

  return (
    <Wrapper>
      <CreateContestContainer>
        <div className="name">
          <h2>{name}</h2>
        </div>

        <CreateContestForm onSubmit={handleSubmit}>
          <div className="date_container">
            <p className="date_text">
              when do you want to start saving(tap to change date)?
            </p>
            <DatePicker
              type="date"
              value={start_date}
              onChange={handleChange}
              name="start_date"
              placeholder="End Date"
            />
          </div>

          <div className="btn_wrapper">
            <Link
              to={'/contest-saving-freq'}
              state={{ backgroundLocation: location }}
            >
              <ModalButton
                onClick={handleDispatch}
                className={`contest_proceed_btn ${Disabled()}`}
              >
                Proceed
              </ModalButton>
            </Link>
          </div>
        </CreateContestForm>
      </CreateContestContainer>
    </Wrapper>
  )
}

export default CreateContest
